import React from 'react'
import PropTypes from 'prop-types'

const FormButtons = ({ children, style = {} }) => (
    <div style={{bottom: 0, marginBottom: '20px', clear: 'both'}}>
        <div style={{padding: '0 20px', ...style}}>
            {children}
        </div>
    </div>
)

FormButtons.propTypes = {
    children: PropTypes.any.isRequired
}

export default FormButtons
